export default "__VITE_ASSET__BpZiPntw__"